/**
 * offers2.js
 * Auto-slide functionality for the "Offers + Rating/Flag" product block.
 * Loaded conditionally via assets/offers-snippet when auto-slide is enabled.
 */
(function () {
  'use strict';

  // Prevent duplicate initialization if script is loaded more than once.
  if (window.__offers2Initialized) return;
  window.__offers2Initialized = true;

  function initOffers2() {
    var carousels = document.querySelectorAll('scroll-carousel[data-auto-slide="true"]');
    if (!carousels.length) return;

    carousels.forEach(function (carousel) {
      // Avoid double-init on the same carousel element.
      if (carousel.dataset.autoSlideReady === 'true') return;
      carousel.dataset.autoSlideReady = 'true';

      var interval = parseInt(carousel.dataset.autoSlideInterval, 10) || 5000;
      var pauseOnHover = carousel.dataset.autoSlidePauseOnHover === 'true';

      var slides = carousel.querySelectorAll('.product-offers__slide');
      var totalSlides = slides.length;
      if (totalSlides <= 1) return;

      // Navigation dots (uses the aria-controls attribute linking back to this carousel).
      var navigation = document.querySelector(
        'carousel-navigation[aria-controls="' + carousel.id + '"]'
      );
      var navButtons = navigation ? navigation.querySelectorAll('button') : [];

      var currentIndex = 0;
      var autoSlideTimer = null;

      function updateNav(index) {
        navButtons.forEach(function (btn, i) {
          btn.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      function goToSlide(index) {
        if (index >= totalSlides) index = 0;
        if (index < 0) index = totalSlides - 1;

        currentIndex = index;

        var slideWidth = slides[0].offsetWidth || carousel.offsetWidth;
        carousel.scrollTo({
          left: slideWidth * index,
          behavior: 'smooth'
        });

        updateNav(index);

        carousel.dispatchEvent(
          new CustomEvent('carousel:slide', { detail: { index: index } })
        );
      }

      function startAutoSlide() {
        if (autoSlideTimer) return;
        autoSlideTimer = setInterval(function () {
          goToSlide(currentIndex + 1);
        }, interval);
      }

      function stopAutoSlide() {
        if (autoSlideTimer) {
          clearInterval(autoSlideTimer);
          autoSlideTimer = null;
        }
      }

      // Kick things off.
      startAutoSlide();

      // Pause on hover (desktop) and touch (mobile).
      if (pauseOnHover) {
        carousel.addEventListener('mouseenter', stopAutoSlide);
        carousel.addEventListener('mouseleave', startAutoSlide);
        carousel.addEventListener('touchstart', stopAutoSlide, { passive: true });
        carousel.addEventListener('touchend', startAutoSlide, { passive: true });
      }

      // Pause temporarily when user clicks a dot, then resume.
      navButtons.forEach(function (btn, index) {
        btn.addEventListener('click', function () {
          stopAutoSlide();
          currentIndex = index;
          updateNav(index);
          setTimeout(startAutoSlide, interval);
        });
      });

      // Pause when tab is not visible (saves CPU / battery).
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stopAutoSlide();
        } else {
          startAutoSlide();
        }
      });

      // Sync current index when user scrolls/swipes manually.
      var scrollTimeout;
      carousel.addEventListener(
        'scroll',
        function () {
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(function () {
            var slideWidth = slides[0].offsetWidth || carousel.offsetWidth;
            var newIndex = Math.round(carousel.scrollLeft / slideWidth);
            if (newIndex !== currentIndex) {
              currentIndex = newIndex;
              updateNav(newIndex);
            }
          }, 100);
        },
        { passive: true }
      );

      // Cleanup on page unload.
      window.addEventListener('beforeunload', stopAutoSlide);
    });
  }

  // Run after DOM is ready (works with both `defer` and dynamic loading).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOffers2);
  } else {
    initOffers2();
  }
})();